<template>
    <searchContainer :searchHandler="search" :resetHandler="reset">
        <template v-slot:items>
            <div class="row">
                <input-number v-model="filters.captain_id" :options="{ id: 'captain_id', step: 1, label: 'captain_id' }"/>
            </div>
            <div class="row">
                <select-countries v-model="filters.country_id" :options="{ id: 'country_id', label: 'country', placeholder: 'placeholders.all', action: countries_list_action, disabled: canNotSelectCountry() }"/>
                <select-cities v-model="filters.city_id" :country_id="filters.country_id" :options="{ id: 'city_id', label: 'city', placeholder: 'placeholders.all', action: cities_list_action, disabled: canNotSelectCity() }"/>
                <input-number v-model="filters.total_working_minutes_from" :options="{ id: 'total_working_minutes_from', step: 1, label: 'total_working_minutes_from' }"/>
                <input-number v-model="filters.total_working_minutes_to" :options="{ id: 'total_working_minutes_to', step: 1, label: 'total_working_minutes_to' }"/>
                <input-number v-model="filters.km_total_distance_from" :options="{ id: 'km_total_distance_from', label: 'km_total_distance_from' }"/>
                <input-number v-model="filters.km_total_distance_to" :options="{ id: 'km_total_distance_to', label: 'km_total_distance_to' }"/>
                <input-number v-model="filters.delivered_orders_count_from" :options="{ id: 'delivered_orders_count_from', step: 1, label: 'delivered_orders_count_from' }"/>
                <input-number v-model="filters.delivered_orders_count_to" :options="{ id: 'delivered_orders_count_to', step: 1, label: 'delivered_orders_count_to' }"/>
            </div>
            <div class="row">
                <input-date v-model="filters.created_from" :options="{ id: 'created_from', label: 'created_from' }"/>
                <input-date v-model="filters.created_to" :options="{ id: 'created_to', label: 'created_to' }"/>
            </div>
        </template>
    </searchContainer>
</template>
<script>

    import {mapGetters} from "vuex";
    import {CRUD_SEARCH_RESET} from "actions/crud";
    import searchContainer from "@/components/crud/card/CardSearch";
    import {COUNTRIES_PUBLIC_LIST} from 'actions/countries';
    import {CITIES_PUBLIC_LIST} from 'actions/cities';

    const CRUD_CODE = "captains_registration_requests";
    export default {
        name: "SuppliersPortalCaptainWorkingSummariesSearch",
        components: {
            searchContainer
        },
        props: {
            listHandler: {
                type: Function,
                default: () => {
                }
            },
        },
        data() {
            return {
                transPrefix: CRUD_CODE,
                filters: {
                    country_id: this.getFilterByKey('country_id'),
                    city_id: this.getFilterByKey('city_id'),
                    captain_id: this.getFilterByKey('captain_id'),
                    total_working_minutes_from: this.getFilterByKey('total_working_minutes_from'),
                    total_working_minutes_to: this.getFilterByKey('total_working_minutes_to'),
                    km_total_distance_from: this.getFilterByKey('km_total_distance_from'),
                    km_total_distance_to: this.getFilterByKey('km_total_distance_to'),
                    delivered_orders_count_from: this.getFilterByKey('delivered_orders_count_from'),
                    delivered_orders_count_to: this.getFilterByKey('delivered_orders_count_to'),
                    created_from: this.getFilterByKey('created_from'),
                    created_to: this.getFilterByKey('created_to'),
                },
                filtersMap: {
                    city_id: 'cityId',
                    captain_id: 'captainId',
                    total_working_minutes_from: 'totalWorkingMinutesGreaterThan',
                    total_working_minutes_to: 'totalWorkingMinutesLessThan',
                    km_total_distance_from: 'kmTotalDistanceGreaterThan',
                    km_total_distance_to: 'kmTotalDistanceLessThan',
                    delivered_orders_count_from: 'deliveredOrdersCountGreaterThan',
                    delivered_orders_count_to: 'deliveredOrdersCountLessThan',
                    created_from: 'startDate',
                    created_to: 'endDate',
                },
                countries_list_action: COUNTRIES_PUBLIC_LIST,
                cities_list_action: CITIES_PUBLIC_LIST,
            }
        },
        mounted() {
            this.setSearchParams(this.filters, this.filtersMap);
        },
        computed: {
            ...mapGetters([
                "getSearchFilters"
            ])
        },
        methods: {
            search() {
                this.resetPagination();
                this.setSearchParams(this.filters, this.filtersMap, {routeParams: this.getFilters(this.filters)});
                this.pushRoute(this.getSearchFilters);
                this.listHandler();
            },
            reset() {
                this.resetPagination();
                this.$store.dispatch(CRUD_SEARCH_RESET);
                this.filters = this.clearFilters(this.filters);
                this.pushRoute();
                this.listHandler();
            },
            resetPagination() {
                //Reset Pagination
                this.$emit('input', 0);
            },
            pushRoute(query = {}) {
                this.$router.push({name: this.$route.name, query}).catch(() => {});
            },
            canSelectCountry() {
                return true;
            },
            canNotSelectCountry() {
                return !this.canSelectCountry();
            },
            canSelectCity() {
                return this.filters.country_id;
            },
            canNotSelectCity() {
                return !this.canSelectCity();
            },
        }
    };
</script>
